module.exports = __webpack_public_path__ + "static/media/(DH)_MG_6308_-_Joias_Contenporaneas.eb385c03.jpg";